import { useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { LoginModalProps } from 'src/components/LoginModal';
import useVerifyCode from 'src/hooks/useVerifyCode';
import { kmcStateAtom } from 'src/stores/kmc/atoms';
import useKmcPopupController from 'src/stores/kmc/useKmcPopupController';
import { fallbackToTSPAtom } from 'src/stores/phoneNumberLogin/atoms';
import { LoginModalType, loginModalTypeAtom, socialKmcVerificationAtom } from 'src/stores/register/atoms';
import LoginEntry from './LoginEntry';
import PhoneNumberLogin from './PhoneNumberLogin';
import SocialLogin from './SocialLogin';
import SocialRegister from './SocialRegister';
import useRegister from './useRegister';
const AzarLoginModal = (props: LoginModalProps) => {
  const loginModalType = useAtomValue(loginModalTypeAtom);
  const kmcState = useAtomValue(kmcStateAtom);
  const setKmcState = useSetAtom(kmcStateAtom);
  const setSocialKmcVerification = useSetAtom(socialKmcVerificationAtom);
  const fallbackToTSP = useSetAtom(fallbackToTSPAtom);
  const {
    handleVerifyKmc
  } = useVerifyCode();
  const {
    tryRegister
  } = useRegister();
  useKmcPopupController();

  // sns KMC 성공 시 credential을 register-scoped atom으로 옮긴 뒤 팝업 세션(kmcState)은 idle로
  // 되돌린다. 이후 단계의 tryRegister는 socialKmcVerificationAtom을 읽으므로 phone의
  // smsVerificationAtom 패턴과 동일하게 credential과 popup session을 분리한다.
  useEffect(() => {
    switch (kmcState.status) {
      case 'verified':
        if (kmcState.entryPoint === 'phone') {
          handleVerifyKmc(kmcState.kmcResultKey);
        } else if (kmcState.entryPoint === 'sns') {
          setSocialKmcVerification({
            resultKey: kmcState.kmcResultKey
          });
          setKmcState({
            status: 'idle'
          });
          void tryRegister();
        }
        break;
      case 'fallback':
        // phone/sns 모두 fallbackToTSP 내부에서 loginModalType으로 분기한다.
        fallbackToTSP();
        break;
      default:
        break;
    }
  }, [fallbackToTSP, handleVerifyKmc, kmcState, setKmcState, setSocialKmcVerification, tryRegister]);
  switch (loginModalType) {
    case LoginModalType.LOGIN_ENTRY:
      return <LoginEntry {...props} />;
    case LoginModalType.SOCIAL_LOGIN:
      return <SocialLogin />;
    case LoginModalType.SOCIAL_REGISTER:
      return <SocialRegister />;
    case LoginModalType.PHONE_NUMBER_LOGIN:
      return <PhoneNumberLogin />;
  }
};
export default AzarLoginModal;